// Aturan password: min. 12 karakter dengan kombinasi huruf besar, huruf kecil, angka, dan simbol.
// Harus sama dengan helpers/passwordPolicy di be-itprasmuleli.
export const PASSWORD_RULE_TEXT = 'Min. 12 karakter dengan kombinasi huruf besar/kecil, angka, dan simbol.'

export const isStrongPassword = (password) =>
    typeof password === 'string' &&
    password.length >= 12 &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9\s]/.test(password)
